import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "../services/shared.service";
import { LOCAL_STORAGE_KEYS, url } from "../global/constant";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offsetMinutes = new Date().getTimezoneOffset();
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);
    if (token) {
      request = request.clone({
        headers: request.headers.set("Authorization", "Bearer " + token),
      });
    }
    if(timeZone){
      request = request.clone({
        headers: request.headers.set("timezone",  timeZone),
      });
    }

     if(offsetMinutes){
      request = request.clone({
        headers: request.headers.set("offsetminutes",  offsetMinutes.toString()),
      });
    }


    request = request.clone({
      headers: request.headers.set("Accept", "application/json"),
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        // if (event instanceof HttpResponse) {
        // }
        return event;
      }),
      catchError((err: HttpErrorResponse) => {
        if (err?.error?.statusCode == 401) {
          // Clear local storage and redirect to session expired page
          localStorage.removeItem(LOCAL_STORAGE_KEYS.accessToken);
          localStorage.removeItem(LOCAL_STORAGE_KEYS.loginUserDetails);
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigateByUrl(url.sessionExpired);
        } else {
          const message = err?.error?.message;
          const errorText = Array.isArray(message) ? message[0] : (message || err?.message || 'Something went wrong');
          this.sharedService.errorToastNotification(errorText);
        }
        return throwError(() => err);
      })
    );
  }
}
